import React, {Component} from 'react';

export default class Project extends Component{
    render(){
        return(
            <article className={this.props.project.first?'first':''}>
                <div className="card">
                    <h3>{this.props.project.name}</h3>
                    <div className="image">
                        {this.props.project.image !== '' &&
                        <a href={this.props.base+'view/'+this.props.project.key} target="_blank" title="In einem neuen Fenster ansehen">
                            <img src={this.props.base+'static/projects/'+this.props.customer.key+'/'+this.props.project.key+'/'+this.props.project.image} alt={this.props.project.description} />
                        </a>
                        }
                    </div>
                    <footer>
                        <button className={'btn customer-style '+(this.props.selected !== null && this.props.project.key === this.props.selected.key ? 'selected': '')} onClick={() => this.props.onClick()} title="Dieses Produkt einbetten oder verlinken"></button>
                        <a className="view-link" href={this.props.base+'view/'+this.props.project.key} target="_blank" title="In einem neuen Fenster ansehen">Ansehen</a>
                    </footer>
                </div>
            </article>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/overview/components/project.component.js